<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('currency') }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="id"
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="goTo('currency')"
          >
            <v-icon
              color="teal"
              style="font-size: 22px"
            >
              mdi-plus-box-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('currency') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo( 'currencyList')"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('currencyList') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="3"
            sm="3"
            class="mb-0  "
          >
              <autocomplete
                v-model="currency"
                :title="$t('currency')"
                type="aiCurrency"
                :disabled="(main == 'yes' ? true : false)"
              />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="symbol"
              :label="$t('symbol')"
              height="20"
              dense
              :rules="[v => !!v || $t('is-required')]"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <money
              v-model="amount"
              :dense="true"
              :label="$t('amount')"
              :outlined="true"
              :rules="[v => !!v || $t('is-required')]"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
              class="mb-3 dense"
              :disabled="(main == 'yes' ? true : false)"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="decimal"
              :label="$t('decimal')"
              height="20"
              dense
              :rules="[v => !!v || $t('is-required')]"
              outlined
              type="number"
              class="mb-1 dense"
              clearable
            />
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="goTo(  'currencyList' )"
            >
              {{ $t('currencyList') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  // import aicomplete from '../../components/general/AIcomplete/index'
  import autocomplete from '../../components/general/patial/autocomplete'
  import General from '../../../../Mixins/general'
  import Snakbar from '../../components/general/snakbar/snakbar'
  export default {
    name: 'Product',
    components: {
      Snakbar,
      autocomplete,
    },
    mixins: [General],
    props: ['formType'],
    data: () => ({
      render: false,
      isLoading: false,
      alert: false,
      main: null,
      currency: null,
      symbol: null,
      decimal: null,
      amount: null,
      valid: null,
      message: null,
      id: null,
      loading: false,
    }),
    watch: {
      snakbar () {
      },
    },
    beforeMount () {
      if (this.$route.params.id != null) {
        this.show()
        this.id = this.$route.params.id
        this.render = false
      } else {
        this.render = true
      }
    },
    mounted () {
    },
    methods: {
      create () {
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'currency', app.$data)
          .then(res => {
            app.goTo('currencyList')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.isLoading = false))
      },
      show () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'currency/' + this.$route.params.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            res = res.data
            app.$nextTick(() => {
              app.id = res.id
              app.main = res.main
              app.currency = res.currency
              app.symbol = res.symbol
              app.amount = res.amount
              app.decimal = res.decimal
              app.render = true
            })
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'currency/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            app.$emit('close', app.$route)
            app.goTo('currencyList')
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
    },
  }
</script>

<style scoped>

</style>
